module.exports = __webpack_public_path__ + "56883234a4fc3a0c10fb1a28a1ead4d4.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fontello/fontello.woff2?67495670
// module id = 8038
// module chunks = 0